import { FlagStatus } from '@modules/HappinessModule/enums/FlagStatus';

export const FlagStatusMapToName = {
  [FlagStatus.Positive]: 'Positive',
  [FlagStatus.Negative]: 'Negative',
  [FlagStatus.InProgress]: 'In progress',
  [FlagStatus.OnHold]: 'On hold',
};
